import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

export const PollNavigation = ({prevPoll, nextPoll}) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  // This is just for UI purposes as requested - no actual DB connection
  const handleNavigateToPrev = () => {
    // console.log("Navigate to previous poll");
    navigate(`/polls/${prevPoll.slug}`);
    // In a real implementation, this would navigate to the previous poll
  };

  const handleNavigateToNext = () => {
    // console.log("Navigate to next poll");
    navigate(`/polls/${nextPoll.slug}`);
    // In a real implementation, this would navigate to the next poll
  };

  if (isMobile) {
    return (
      <div className="w-full flex justify-between items-center mb-4">
        <button
          onClick={handleNavigateToPrev}
          className="flex items-center gap-2 text-gray-600 hover:text-primary dark:text-gray-400 dark:hover:text-white transition-colors"
        >
          <ChevronLeft className="h-5 w-5" />
          <span>Previous Poll</span>
        </button>

        <button
          onClick={handleNavigateToNext}
          className="flex items-center gap-2 text-gray-600 hover:text-primary dark:text-gray-400 dark:hover:text-white transition-colors"
        >
          <span>Next Poll</span>
          <ChevronRight className="h-5 w-5" />
        </button>
      </div>
    );
  }

  return (
    <>
      <HoverCard openDelay={100} closeDelay={100}>
        <HoverCardTrigger asChild>
          <button
            onClick={handleNavigateToPrev}
            className="hidden md:flex items-center justify-center text-gray-600 hover:text-primary dark:text-gray-400 dark:hover:text-white transition-colors fixed left-4 top-1/3 -translate-y-1/2 z-10 bg-white dark:bg-gray-800 rounded-full p-3 shadow-md border border-gray-200 dark:border-gray-700 hover:shadow-lg"
            aria-label="Previous Poll"
            disabled={!prevPoll}
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
        </HoverCardTrigger>
        {prevPoll &&
            <HoverCardContent side="right" className="p-2 text-sm animate-fade-in">
              {/*<p className="font-medium">Which movie will win the Oscar?</p>*/}
              <p className="font-medium">{prevPoll?.title}</p>
            </HoverCardContent>
        }
      </HoverCard>

      <HoverCard openDelay={100} closeDelay={100}>
        <HoverCardTrigger asChild>
          <button
            onClick={handleNavigateToNext}
            className="hidden md:flex items-center justify-center text-gray-600 hover:text-primary dark:text-gray-400 dark:hover:text-white transition-colors fixed right-4 top-1/3 -translate-y-1/2 z-10 bg-white dark:bg-gray-800 rounded-full p-3 shadow-md border border-gray-200 dark:border-gray-700 hover:shadow-lg"
            aria-label="Next Poll"
            disabled={!nextPoll}
          >
            <ChevronRight className="h-6 w-6" />
          </button>
        </HoverCardTrigger>
        {nextPoll &&
            <HoverCardContent side="left" className="p-2 text-sm animate-fade-in">
          {/*<p className="font-medium">Who will be the next president?</p>*/}
          <p className="font-medium">{nextPoll?.title}</p>
        </HoverCardContent>
        }
      </HoverCard>
    </>
  );
};
